import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalConstantsService {

  constructor() { }
  private static candidateXLTitleVariableMappingJSON: Object = {
    "name" : "candidateName",
    "email" : "email",
    "contact number" : "contactNo",
    "address" : "address",
    "date of birth" : "dob",
    "gender" : "gender",
    "total marks" : "totalMarks",
    "mark scored" : "score",
    "attempt status" : "attemptStatus",
    "report link" : "reportUrl"
  };

  private static panelMemberXLTitleVariableMappingJSON: Object = {
    "name" : "panelMemberName",
    "email": "email",
    "contact number": "contactNo"
  };

  public static meetingLinkProviderEnum: Object = {
    "MOVIE": "MOVIE"
  };

  public static XLTitleVariableMapper(titleObjectList: Array<JSON>, purpose: string) : Array<JSON> {
    const variableObjectList = [];
    titleObjectList.forEach(titleObject => {
      let variableObject = {};
      Object.keys(titleObject).forEach(key => {
        switch(purpose) {
          case 'CANDIDATE': {
            variableObject[this.candidateXLTitleVariableMappingJSON[key.toLowerCase().trim()]] = titleObject[key];
            break;
          }
          case 'PANEL-MEMBER': {
            variableObject[this.panelMemberXLTitleVariableMappingJSON[key.toLowerCase().trim()]] = titleObject[key];
            break;
          }
        }
      });
      variableObjectList.push(variableObject);
    });
    return variableObjectList;
  }
}
